import { UPDATE_EVENT } from 'root/src/client/logic/dropEvent/actionIds'

export default payload => ({
	type: UPDATE_EVENT,
	payload,
})
